import React from 'react';
import '../Login/Login.css';
import { Redirect } from "react-router-dom";
import LogoLoginRole from '../Logo/LogoLoginRole';
import Ulylogo from '../Logo/logoUlysses';
import setUserAction from '../../actions/setUserAction'
import setUserFullData from '../../actions/setUserFullData'
import setStateAction from '../../actions/setStateAction'
import setStateDefaultRoleID from '../../actions/setStateDefaultRoleID'
import setUserNameAction from '../../actions/setActionUserName'
import { connect } from 'react-redux'
import FetchData from '../Utils/FetchData';
import { UserAgentApplication } from 'msal';
import SvgUser from '../../iconComponents/usertextboxIcon';
import Svglock from '../../iconComponents/locktextboxIcon';
const $ = window.$;
function disableF5(e) { if ((e.which || e.keyCode) == 116) e.preventDefault(); };

let span;

var folderid = null
var roleid = null
var taskid = null
var dirid = null

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            status: '',
            message: '',
            data: [],
            count: 0,
            disable: false,
            isChecked: false,
            msalConfig: null,

        }
        //TM(Thanasis Mourselas):Bind event handlers
        this.login = this.login.bind(this);
        this.onchange = this.onchange.bind(this);
        this.azurelogin = this.azurelogin.bind(this);
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search)
        folderid = query.get('folderid')
        roleid = query.get('roleid')
        taskid = query.get('taskid')
        dirid = query.get('dirid')
        this.props.history.push("")
        this.getSecurityContext()
    }

    //TM(Thanasis Mourselas):event when user is logged in
    login(e) {
        this.props.setState(undefined)
        var userURL


        e.preventDefault()
       
        this.props.nameUserSet(this.state.username)
        //TM(Thanasis Mourselas):post to web api username and password for user authentication
        var postData = {
            username: this.state.username,
            password: this.state.password,
            attempt: this.state.count
        };

        //TM(Thanasis Mourselas): Fetch data to validate user credentials
        FetchData('/api/WRU/ValidateUserObj/0', 'POST', postData)
            .then(response => {
                this.props.userSet(JSON.parse(response.data).Id)
                this.props.userSetFullData(JSON.parse(response.data))

                userURL = response.data


                this.props.setStateDefaultRoleID(JSON.parse(response.data).IddefaultRole)
                //this.props.setStateDefaultRoleNAME(JSON.parse(response.data).IddefaultRole) 
                let userIdnumber = Object.values(JSON.parse(userURL))
                localStorage.setItem('authToken', response.token);

                this.setState({
                    status: response.status,
                    messages: response.messages[0],
                });

                //TM(Thanasis Mourselas): Redirect only if the user redirect to Task View using URL with parameters
                if (folderid !== null && folderid !== undefined) {
                    const url = window.location.origin
                        + "/taskview?folderid=" + folderid
                        + "&roleid=" + roleid
                        + "&taskid=" + taskid
                        + "&dirid=" + dirid
                    window.open(url, '_self');

                }
            })
            .catch(error => {

                this.setState({
                    status: error.status,
                    messages: error.messages[0],
                    data: error.data
                });
                if (error.status == '1') {
                    this.setState({
                        count: this.state.count + 1
                    });
                }
                if (error.messages[0] == 'Too many attempts. Login disabled.') {
                    this.setState({
                        disable: true
                    });
                } else {
                    this.setState({
                        disable: false
                    });
                }
            })
    }
    //TM(Thanasis Mourselas):event for text boxes username and password
    onchange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    getSecurityContext() {
        FetchData('/api/WRU/GetSecurityContext/')
            .then((data) => {
                if (data.data.EnableAzureAdAuthentication.toUpperCase() === "TRUE") {
                    var msalConfiguration = {
                        auth: {
                            clientId: data.data.ClientAppID, //"1a551d44-5a71-4e75-80e3-eab1013949c1", //replace with clientID obtained by the API
                            authority: "https://login.microsoftonline.com/" + data.data.TenantID, //"https://login.microsoftonline.com/e7a2c41b-168c-45cf-b694-1f2dab6559a3", //replace the guid with tenantID obtained by the API
                            redirectUri: data.data.RedirectURI //"http://localhost:5001/" //replace with redirect URI obtained by the API
                        },
                        scopes: [
                            data.data.APIScope
                            //'https://ms.sarrigiannis.gmail.com/tawebapi/TAUsers'  //replace with API Score obtained by the API
                        ]
                    };
                    this.setState({ msalConfig: msalConfiguration })
                }
            }).catch(error => {
              
            })
    }

    async azurelogin() {
        try {
            //Create Azure AD configuration object
            var userAgentApp = new UserAgentApplication(this.state.msalConfig)

            // Login via popup
            await userAgentApp.loginPopup(
                {
                    scopes: this.state.msalConfig.scopes,
                    prompt: "select_account"
                });

            // Retrieve access token
            var res = await userAgentApp.acquireTokenSilent({
                scopes: this.state.msalConfig.scopes
            });

            var loginData = await fetch(window.Configs.APIURL + '/api/WRU/ValidateAzureADUser/' + encodeURIComponent(res.account.userName), {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + res.accessToken,
                    'TAVersion': 'Web'
                },
            })
            loginData = await loginData.json()

            this.props.userSet(JSON.parse(loginData.data).Id)
            this.props.setStateDefaultRoleID(JSON.parse(loginData.data).IddefaultRole)
            localStorage.setItem('authToken', loginData.token);

            this.setState({
                status: loginData.status,
                messages: loginData.messages[0],
            });

            //Redirect only if the user redirect to Task View using URL with parameters
            if (folderid !== null && folderid !== undefined) {
                const url = window.location.origin
                    + "/taskview?folderid=" + folderid
                    + "&roleid=" + roleid
                    + "&taskid=" + taskid
                    + "&dirid=" + dirid
                window.open(url, '_self');

            }
        }
        catch (err) {
            // console.log(err)
        }
    }

    componentDidUpdate() {
        if (this.state.msalConfig !== null && this.state.status === '') {
            if (this.state.disable === false) {
                this.setState({
                    disable: true
                });
            }
            this.azurelogin()
        }
    }
    render() {
        var styles
        //TM(Thanasis Mourselas):if events == 200 user is authenticated redirect to role authorization     
        if (this.state.status == "0") {
            return (<Redirect to={{ pathname: '/Role', state: { userName: this.state.username } }} />)
        }

        //TM(Thanasis Mourselas):let span message when user authenticate is failed
        //TM(Thanasis Mourselas):if events == 400 user is not authenticated
        if (this.state.status == "1") {
            if (this.state.messages === 'Invalid User Name') {
                document.getElementById("input").style.borderColor = "#C82437";
                document.getElementById("input").style.borderStyle = "solid";
                document.getElementById("input").style.boxShadow = "0px 3px 6px #C824374D";
            }
            if (this.state.messages === 'Invalid User Name/Password') {
                document.getElementById("pass").style.borderColor = "#C82437";
                document.getElementById("pass").style.borderStyle = "solid";
                document.getElementById("pass").style.boxShadow = "0px 3px 6px #C824374D";
            }


            span = <span className="focus-input100" style={{ color: '#C82437', fontSize: '14px', fontFamily: 'Roboto Condensed' }}
            >{this.state.messages}</span>

        }

        return (
            <div className="limiter">
                <div className="container-login100">
                    <div className="login100-more"></div>
                    <div className="wrap-login100 p-l-50 p-r-50 p-t-72 p-b-50">
                        <form className="login100-form validate-form" onSubmit={this.onSubmit}>
                            <span className="login100-form-title p-b-59">
                                {/*Logo component*/}
                                <LogoLoginRole />
                            </span>
                            <span className="login100-form-secondtitle p-b-59">
                                Please enter your authentication details
                            </span>
                            <div className="wrap-inputUser validate-input">
                                <label className="label-input100">User name</label>
                                <div className="row">
                                    <div className="icon">
                                        <SvgUser />
                                    </div>
                                    <input
                                        autofocus
                                        id="input"
                                        disabled={this.state.disable}
                                        name="username"
                                        onChange={this.onchange}
                                        //placeholder="Username..."
                                        type="text"
                                    />
                                </div>


                            </div>
                            <div className="wrap-inputPass validate-input">
                                <label className="label-input100">Password</label>

                                <div className="row">
                                    <div className="icon">
                                        <Svglock />
                                    </div>
                                    <input
                                        id="pass"
                                        disabled={this.state.disable}
                                        //className="input100"
                                        name="password"
                                        type="password"
                                        onChange={this.onchange}
                                    //placeholder="*************"
                                    />
                                </div>
                                {span}
                            </div>
                            <div >
                                <div className="buttonClass" >

                                    <button
                                        disabled={this.state.disable}
                                        className="login100-form-btn"
                                        onClick={() => { this.submit() }}
                                        name="Login"
                                        type="button"
                                        onClick={this.login}
                                        value="Login"
                                        usernamechange={this.login.bind(this)}>
                                        Login
						            </button>
                                </div>
                            </div>
                        </form>
                        <div className="BottomDiv">
                            <p className="BottomLogoLogin" style={{ marginLeft: '-30px', fontSize: '12px' }}><Ulylogo /></p>
                            <p className="ulyUrl"><span>www.ulysses-systems.com</span></p>
                        </div>

                    </div>

                </div>

            </div>

        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        userSet: payload => dispatch(setUserAction(payload)),
        userSetFullData: payload => dispatch(setUserFullData(payload)),
        setState: payload => dispatch(setStateAction(payload)),
        setStateDefaultRoleID: payload => dispatch(setStateDefaultRoleID(payload)),
        nameUserSet: payload => dispatch(setUserNameAction(payload))

    };
};
export default connect(null, mapDispatchToProps)(LoginForm);




// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js